module.exports = __webpack_public_path__ + "static/media/Fluxwheel-howitwork.46719e61.png";